














import Vue from 'vue';

enum NotIn {
  No = 0,
  Yes = 1,
}

const value: string | undefined = undefined;

export default Vue.extend({
  props: {
    notIn: {
      type: Boolean,
      default: false,
    },
    or: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      value,
    };
  },
  methods: {
    updateRelation(values: string) {
      const [notIn, or] = values.split(',');
      this.$emit('change', notIn === 'true', or === 'true');
    },
  },
  mounted() {
    this.value = [this.notIn, this.or].join(',');
  },
});
